"use client";
import { forwardRef } from "react";
import AppSnackbar from "./AppSnackbar";
import { SnackbarTypeEnum } from "@/models";
import { CustomContentProps } from "notistack";

const AppSnackbarWarning = forwardRef<
  HTMLDivElement,
  CustomContentProps & { type?: SnackbarTypeEnum }
>(({ type = SnackbarTypeEnum.Warning, ...props }, ref) => {
  return <AppSnackbar {...props} type={type} ref={ref} />;
});

AppSnackbarWarning.displayName = "AppSnackbarWarning";
export default AppSnackbarWarning;
